/* ----------- UCOutsideClickHandler -----------  */

/* --- Imports ---  */
/* Libraries  */
import React, { useEffect, useRef } from "react";

/* Third Party Components  */

/* Components, Services, Utils  */

/* Styles */

const UCOutsideClickHandler = ({
  onOutsideClick = (event) => console.log("no handler for ", event),
  className,
  children,
}) => {
  const wrapperRef = useRef(null);

  // Lifecycle
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onOutsideClick]);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      onOutsideClick();
    }
  };

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default UCOutsideClickHandler;
